var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isLoggedIn
    ? _c(
        "b-container",
        {
          directives: [
            {
              name: "animate-css",
              rawName: "v-animate-css",
              value: "fadeIn",
              expression: "'fadeIn'",
            },
          ],
          staticClass: "dashboard",
          attrs: { fluid: "" },
        },
        [
          _c(
            "div",
            { staticClass: "dashContent" },
            [
              _c(
                "b-row",
                { staticClass: "dashRow firstDash" },
                [
                  _c("b-col", { attrs: { md: "4" } }, [
                    _vm.userProfile.profileData
                      ? _c(
                          "div",
                          { staticClass: "userProfile" },
                          [
                            !_vm.userProfile.profileData.mbsdFile
                              ? _c("img", {
                                  staticClass: "avatar",
                                  attrs: {
                                    src: "/public/images/anonymous.jpg",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userProfile.profileData.mbsdFile
                              ? _c("img", {
                                  staticClass: "avatar",
                                  attrs: {
                                    src:
                                      "https://facepool.oss-ap-southeast-5.aliyuncs.com/" +
                                      _vm.userProfile.profileData.mbsdFile,
                                  },
                                  on: { error: _vm.photoProfileError },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("h5", { staticClass: "greetings" }, [
                              _vm._v("Sugeng Rawuh,"),
                            ]),
                            _vm._v(" "),
                            _c("h4", [
                              _vm._v(
                                _vm._s(_vm.userProfile.profileData.mbsdFullName)
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  to: "/profile",
                                  pill: "",
                                  variant: "outline-secondary",
                                  size: "sm",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("user.linktoprofile")) + " "
                                ),
                                _c("b-icon", {
                                  attrs: { icon: "arrow-right" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "funFacts" }, [
                      _c("label", { staticClass: "textLabel" }, [
                        _vm._v(_vm._s(_vm.$t("user.trivia"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { domProps: { innerHTML: _vm._s(_vm.fact) } }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { md: "8" } }, [
                    _c(
                      "div",
                      { staticClass: "mainCard" },
                      [
                        _c(
                          "b-card",
                          {
                            attrs: {
                              "img-src": "/public/images/reg.jpg",
                              "img-alt": "Registration",
                              "img-top": "",
                            },
                          },
                          [
                            _c("div", { staticClass: "statusContainer" }, [
                              _vm.ballotStatus.readyToRegister
                                ? _c(
                                    "div",
                                    { staticClass: "statusIdle" },
                                    [
                                      _c("h2", [
                                        _vm._v(
                                          _vm._s(_vm.$t("status.idle.head"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-form",
                                        { on: { submit: _vm.onSubmit } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "",
                                                label:
                                                  _vm.$t("status.idle.label"),
                                                "label-for": "",
                                                description:
                                                  _vm.$t("status.idle.desc"),
                                              },
                                            },
                                            [
                                              _c("b-form-select", {
                                                attrs: {
                                                  options: _vm.regChannel,
                                                },
                                                model: {
                                                  value: _vm.channel,
                                                  callback: function ($$v) {
                                                    _vm.channel = $$v
                                                  },
                                                  expression: "channel",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              directives: [
                                                {
                                                  name: "b-modal",
                                                  rawName:
                                                    "v-b-modal.registrationModal",
                                                  modifiers: {
                                                    registrationModal: true,
                                                  },
                                                },
                                              ],
                                              attrs: {
                                                variant: "primary",
                                                disabled: _vm.channel == null,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("status.idle.btn")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("registration-modal", {
                                            attrs: {
                                              "modal-data": _vm.channel,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.ballotStatus.waiting
                                ? _c(
                                    "div",
                                    { staticClass: "statusWait" },
                                    [
                                      _c("h2", [
                                        _vm._v(
                                          _vm._s(_vm.$t("status.wait.head"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "status" },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { sm: "auto" } },
                                            [
                                              _c("svg-image", {
                                                attrs: { image: "statusWait" },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("b-col", [
                                            _c("h6", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("status.wait.label")
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("status.wait.desc")
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.ballotStatus.frqWaiting
                                ? _c(
                                    "div",
                                    { staticClass: "statusFRQWait" },
                                    [
                                      _c("h2", [
                                        _vm._v(
                                          _vm._s(_vm.$t("status.FRQwait.head"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "status" },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { sm: "auto" } },
                                            [
                                              _c("svg-image", {
                                                attrs: { image: "statusWait" },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("b-col", [
                                            _c("h6", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("status.FRQwait.label")
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t("status.FRQwait.desc")
                                                ),
                                              },
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.ballotStatus.fastRunnerRejected
                                ? _c(
                                    "div",
                                    { staticClass: "statusSwitched" },
                                    [
                                      _c("h2", [
                                        _vm._v(
                                          _vm._s(_vm.$t("status.switched.head"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "status" },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { sm: "auto" } },
                                            [
                                              _c("svg-image", {
                                                attrs: {
                                                  image: "statusSwitched",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("b-col", [
                                            _c("h6", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.switched.label"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t("status.switched.desc")
                                                ),
                                              },
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.ballotStatus.drawing
                                ? _c(
                                    "div",
                                    { staticClass: "statusDrawing" },
                                    [
                                      _c("h2", [
                                        _vm._v(
                                          _vm._s(_vm.$t("status.drawing.head"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "status" },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { sm: "auto" } },
                                            [
                                              _c("svg-image", {
                                                attrs: {
                                                  image: "statusDrawing",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("b-col", [
                                            _c("h6", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("status.drawing.label")
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("status.drawing.desc")
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.ballotStatus.approved && _vm.transactionData
                                ? _c(
                                    "div",
                                    { staticClass: "statusPay" },
                                    [
                                      _c("h2", [
                                        _vm._v(
                                          _vm._s(_vm.$t("status.pay.head"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "status" },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { sm: "auto" } },
                                            [
                                              _c("svg-image", {
                                                attrs: { image: "statusPay" },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            [
                                              _c("h6", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("status.pay.label")
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "i18n",
                                                {
                                                  attrs: {
                                                    path: "status.pay.desc",
                                                    tag: "p",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        place: "timelimit",
                                                      },
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f("moment")(
                                                              _vm
                                                                .transactionData
                                                                .data
                                                                .trnsExpiredTime,
                                                              "D MMMM YYYY HH:mm"
                                                            )
                                                          ) + " WIB (GMT+7)"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          directives: [
                                            {
                                              name: "b-modal",
                                              rawName: "v-b-modal.jerseyModal",
                                              modifiers: { jerseyModal: true },
                                            },
                                          ],
                                          attrs: { variant: "primary" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("status.pay.jbtn"))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("jersey-modal"),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          directives: [
                                            {
                                              name: "b-modal",
                                              rawName: "v-b-modal.paymentModal",
                                              modifiers: { paymentModal: true },
                                            },
                                          ],
                                          attrs: { variant: "primary" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("status.pay.btn"))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("payment-modal", {
                                        attrs: {
                                          transactionData: _vm.transactionData,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.ballotStatus.bibTransferInProgess
                                ? _c(
                                    "div",
                                    { staticClass: "statusTransferring" },
                                    [
                                      _c("h2", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("status.transferring.head")
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "status" },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { sm: "auto" } },
                                            [
                                              _c("svg-image", {
                                                attrs: {
                                                  image: "statusTransferring",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("b-col", [
                                            _c("h6", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.transferring.label"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.transferring.desc"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.ballotStatus.confirmed
                                ? _c(
                                    "div",
                                    { staticClass: "statusSuccess" },
                                    [
                                      _c("h2", [
                                        _vm._v(
                                          _vm._s(_vm.$t("status.success.head"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "status" },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { sm: "auto" } },
                                            [
                                              _c("svg-image", {
                                                attrs: {
                                                  image: "statusSuccess",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("b-col", [
                                            _c("h6", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("status.success.label")
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("status.success.desc")
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.ballotStatus.confirmedViaBankJateng
                                ? _c(
                                    "div",
                                    { staticClass: "statusBJsuccess" },
                                    [
                                      _c("h2", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("status.BJsuccess.head")
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "status" },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { sm: "auto" } },
                                            [
                                              _c("img", {
                                                staticClass: "bankJateng",
                                                attrs: {
                                                  src: "https://assets.heartwork.co.id/bormar/bankjateng.svg",
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("b-col", [
                                            _c("h6", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.BJsuccess.label"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.BJsuccess.desc"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.ballotStatus.unlucky
                                ? _c(
                                    "div",
                                    { staticClass: "statusUnlucky" },
                                    [
                                      _c("h2", [
                                        _vm._v(
                                          _vm._s(_vm.$t("status.unlucky.head"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "status" },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { sm: "auto" } },
                                            [
                                              _c("svg-image", {
                                                attrs: {
                                                  image: "statusUnlucky",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("b-col", [
                                            _c("h6", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("status.unlucky.label")
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("status.unlucky.desc")
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.ballotStatus.unpaid
                                ? _c(
                                    "div",
                                    { staticClass: "statusUnpaid" },
                                    [
                                      _c("h2", [
                                        _vm._v(
                                          _vm._s(_vm.$t("status.unpaid.head"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "status" },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { sm: "auto" } },
                                            [
                                              _c("svg-image", {
                                                attrs: {
                                                  image: "statusUnpaid",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("b-col", [
                                            _c("h6", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("status.unpaid.label")
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("status.unpaid.desc")
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.ballotStatus.transferred
                                ? _c(
                                    "div",
                                    { staticClass: "statusTransferred" },
                                    [
                                      _c("h2", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("status.transferred.head")
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "status" },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { sm: "auto" } },
                                            [
                                              _c("svg-image", {
                                                attrs: {
                                                  image: "statusTransferred",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("b-col", [
                                            _c("h6", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.transferred.label"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.transferred.desc"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.ballotStatus.closed
                                ? _c(
                                    "div",
                                    { staticClass: "statusClosed" },
                                    [
                                      _c("h2", [
                                        _vm._v(
                                          _vm._s(_vm.$t("status.closed.head"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "status" },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { sm: "auto" } },
                                            [
                                              _c("svg-image", {
                                                attrs: {
                                                  image: "statusClosed",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("b-col", [
                                            _c("h6", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("status.closed.label")
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t("status.closed.desc")
                                                ),
                                              },
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _vm.ballotData && _vm.ballotDataDetail
                              ? _c(
                                  "div",
                                  { staticClass: "regData" },
                                  [
                                    _c(
                                      "b-row",
                                      { staticClass: "regCategory" },
                                      [
                                        _c("b-col", { attrs: { md: "auto" } }, [
                                          _c(
                                            "div",
                                            { staticClass: "groupLabel" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "regData.category.race"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("h1", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.ballotDataDetail
                                                  .evrlEvpaCategory
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("b-col", [
                                          _c(
                                            "div",
                                            { staticClass: "groupLabel" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "regData.category.code"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("h5", [
                                            _vm._v(
                                              _vm._s(_vm.ballotData.mregOrderId)
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("moment")(
                                                  _vm.ballotData
                                                    .mregCreatedTime,
                                                  "D MMMM YYYY - HH:mm"
                                                )
                                              ) + " WIB (GMT+7)"
                                            ),
                                          ]),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "groupLabel" }, [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(_vm.$t("regData.details.head"))
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("table", [
                                      _c("tbody", [
                                        _c("tr", [
                                          _c("td", { staticClass: "heady" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("regData.details.corral")
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.ballotDataDetail.evpaWave
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("tr", [
                                          _c("td", { staticClass: "heady" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("regData.details.bib")
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.ballotDataDetail.evpaBIBName
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _vm.ballotDataDetail.evpaJersey != "-"
                                          ? _c("tr", [
                                              _c(
                                                "td",
                                                { staticClass: "heady" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "regData.details.jersey"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.ballotDataDetail
                                                      .evpaJersey
                                                  )
                                                ),
                                              ]),
                                            ])
                                          : _vm._e(),
                                        _c("tr", [
                                          _c("td", { staticClass: "heady" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "regData.details.community"
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.ballotDataDetail
                                                  .evpaCommunity
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _vm.userProfile.fastRunnerInfo
                                      ? _c("div", { staticClass: "FRQdata" }, [
                                          _c(
                                            "div",
                                            { staticClass: "groupLabel" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("regData.frq.head")
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("table", [
                                            _c("tbody", [
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "heady" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "regData.frq.qrace"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.userProfile
                                                        .fastRunnerInfo
                                                        .mmfrEventName
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "heady" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "regData.frq.qcategory"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.userProfile
                                                        .fastRunnerInfo
                                                        .mmfrDescription
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "heady" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "regData.frq.qtime"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.userProfile
                                                        .fastRunnerInfo
                                                        .mmfrResultTime
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                            ]),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "groupLabel" }, [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("regData.emergency.head")
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("table", [
                                      _c("tbody", [
                                        _c("tr", [
                                          _c("td", { staticClass: "heady" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("regData.emergency.name")
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.ballotDataDetail
                                                  .evpaEmergencyContactName
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("tr", [
                                          _c("td", { staticClass: "heady" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "regData.emergency.number"
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.ballotDataDetail
                                                  .evpaEmergencyContactNumber
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("tr", [
                                          _c("td", { staticClass: "heady" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "regData.emergency.medic"
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.ballotDataDetail
                                                  .evpaMedicalTreatment
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "dashRow" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-card-group",
                        { staticClass: "dashDisabled", attrs: { deck: "" } },
                        [
                          _c(
                            "b-card",
                            {
                              staticClass: "dashCard",
                              attrs: {
                                title: _vm.$t("friendship.card.head"),
                                "img-src": "/public/images/fr.jpg",
                                "img-alt": "Friendship Run",
                                "img-top": "",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "friendshipCard" },
                                [
                                  _c("b-card-text", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t("friendship.card.desc")) +
                                        "\n\t\t\t\t\t\t"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-modal",
                                          rawName:
                                            "v-b-modal.registrationModal",
                                          modifiers: {
                                            registrationModal: true,
                                          },
                                        },
                                      ],
                                      attrs: {
                                        block: "",
                                        variant: "primary",
                                        disabled: "disabled",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.channel = "FRIENDSHIP"
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("friendship.card.btn"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.transactionStatus
                                ? _c(
                                    "div",
                                    { staticClass: "friendshipStatus" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "statusPay" },
                                        [
                                          _c(
                                            "b-row",
                                            { staticClass: "status" },
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c("svg-image", {
                                                    attrs: {
                                                      image: "statusPay",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("h6", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "friendship.status.pay.label"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("p", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.$t(
                                                          "friendship.status.pay.desc"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              directives: [
                                                {
                                                  name: "b-modal",
                                                  rawName:
                                                    "v-b-modal.paymentModal",
                                                  modifiers: {
                                                    paymentModal: true,
                                                  },
                                                },
                                              ],
                                              attrs: {
                                                block: "",
                                                variant: "primary",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "friendship.status.pay.btn"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "statusUnpaid" },
                                        [
                                          _c(
                                            "b-row",
                                            { staticClass: "status" },
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c("svg-image", {
                                                    attrs: {
                                                      image: "statusUnpaid",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("h6", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "friendship.status.unpaid.label"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "friendship.status.unpaid.desc"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              directives: [
                                                {
                                                  name: "b-modal",
                                                  rawName: "v-b-modal.busModal",
                                                  modifiers: { busModal: true },
                                                },
                                              ],
                                              attrs: {
                                                block: "",
                                                variant: "primary",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "friendship.status.unpaid.btn"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "statusSuccess" },
                                        [
                                          _c(
                                            "b-row",
                                            { staticClass: "status" },
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c("svg-image", {
                                                    attrs: {
                                                      image: "statusSuccess",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("h6", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "friendship.status.success.label"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "friendship.status.success.desc"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.transactionStatus
                                ? _c(
                                    "div",
                                    { staticClass: "friendshipReg" },
                                    [
                                      _c("table", [
                                        _c("tbody", [
                                          _c("tr", [
                                            _c("td", { staticClass: "heady" }, [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "friendship.data.code"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\tLARI2020\n\t\t\t\t\t\t\t"
                                              ),
                                            ]),
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", { staticClass: "heady" }, [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "friendship.data.bib"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t1234\n\t\t\t\t\t\t\t"
                                              ),
                                            ]),
                                          ]),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            href: "https://borobudurmarathon.com/friendship-run",
                                            block: "",
                                            variant: "primary",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("friendship.data.btn")
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-card",
                            {
                              staticClass: "dashCard",
                              attrs: {
                                title: _vm.$t("shuttle.card.head"),
                                "img-src": "/public/images/bus.jpg",
                                "img-alt": "Shuttle Bus",
                                "img-top": "",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "busCard" },
                                [
                                  _c("b-card-text", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t("shuttle.card.desc")) +
                                        "\n\t\t\t\t\t\t"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-modal",
                                          rawName: "v-b-modal.busModal",
                                          modifiers: { busModal: true },
                                        },
                                      ],
                                      attrs: {
                                        block: "",
                                        variant: "primary",
                                        disabled: "disabled",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("shuttle.card.btn")))]
                                  ),
                                  _vm._v(" "),
                                  _c("bus-modal"),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.transactionStatus
                                ? _c("div", { staticClass: "busStatus" }, [
                                    _c(
                                      "div",
                                      { staticClass: "statusPay" },
                                      [
                                        _c(
                                          "b-row",
                                          { staticClass: "status" },
                                          [
                                            _c(
                                              "b-col",
                                              [
                                                _c("svg-image", {
                                                  attrs: { image: "statusPay" },
                                                }),
                                                _vm._v(" "),
                                                _c("h6", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "shuttle.status.pay.label"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("p", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t(
                                                        "shuttle.status.pay.desc"
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "b-modal",
                                                rawName:
                                                  "v-b-modal.paymentModal",
                                                modifiers: {
                                                  paymentModal: true,
                                                },
                                              },
                                            ],
                                            attrs: {
                                              block: "",
                                              variant: "primary",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("shuttle.status.pay.btn")
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "statusUnpaid" },
                                      [
                                        _c(
                                          "b-row",
                                          { staticClass: "status" },
                                          [
                                            _c(
                                              "b-col",
                                              [
                                                _c("svg-image", {
                                                  attrs: {
                                                    image: "statusUnpaid",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("h6", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "shuttle.status.unpaid.label"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "shuttle.status.unpaid.desc"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "b-modal",
                                                rawName: "v-b-modal.busModal",
                                                modifiers: { busModal: true },
                                              },
                                            ],
                                            attrs: {
                                              block: "",
                                              variant: "primary",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "friendship.status.unpaid.btn"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "statusSuccess" },
                                      [
                                        _c(
                                          "b-row",
                                          { staticClass: "status" },
                                          [
                                            _c(
                                              "b-col",
                                              [
                                                _c("svg-image", {
                                                  attrs: {
                                                    image: "iconBusTicket",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("h6", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "shuttle.status.success.label"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "shuttle.status.success.desc"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.transactionStatus
                                ? _c("div", { staticClass: "busTicket" }, [
                                    _c("table", [
                                      _c("tbody", [
                                        _c("tr", [
                                          _c("td", { staticClass: "heady" }, [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t("shuttle.data.code")
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\tBUS2020\n\t\t\t\t\t\t\t"
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", { staticClass: "heady" }, [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t("shuttle.data.point")
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\tTelevisi Republik Indonesia Yogyakarta\n\t\t\t\t\t\t\t"
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", { staticClass: "heady" }, [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t("shuttle.data.dep")
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t02.00 - 02.30 WIB (GMT+7)\n\t\t\t\t\t\t\t"
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", { staticClass: "heady" }, [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t("shuttle.data.ret")
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t12.00 WIB (GMT+7)\n\t\t\t\t\t\t\t"
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-card",
                            {
                              staticClass: "dashCard",
                              attrs: {
                                title: _vm.$t("bib.card.head"),
                                "img-src": "/public/images/bib.jpg",
                                "img-alt": "Bib Transfer",
                                "img-top": "",
                              },
                            },
                            [
                              _c("b-card-text", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(_vm.$t("bib.card.desc")) +
                                    "\n\t\t\t\t\t"
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal.bibModal",
                                      modifiers: { bibModal: true },
                                    },
                                  ],
                                  attrs: {
                                    block: "",
                                    variant: "primary",
                                    disabled: "disabled",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("bib.card.btn")))]
                              ),
                              _vm._v(" "),
                              _c("bib-modal"),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "dashRow" },
                [
                  _vm.racepackReady
                    ? _c("b-col", { attrs: { md: "8" } }, [
                        _c(
                          "div",
                          { staticClass: "mainCard" },
                          [
                            _c(
                              "b-card",
                              {
                                attrs: {
                                  "img-src": "/public/images/rpc.jpg",
                                  "img-alt": "Race Pack Collection",
                                  "img-top": "",
                                },
                              },
                              [
                                _c("h2", [
                                  _vm._v(_vm._s(_vm.$t("rpc.card.head"))),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(_vm._s(_vm.$t("rpc.card.desc"))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "rpcInfo" },
                                  [
                                    _c(
                                      "b-row",
                                      [
                                        _c("b-col", {
                                          staticClass: "rpcSchedule",
                                          attrs: { md: "7" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t("rpc.schedule")
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("b-col", {
                                          attrs: { md: "5" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t("rpc.venue")
                                            ),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "groupLabel" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.$t("rpc.instructions.label"))
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.ballotData
                                  ? _c(
                                      "b-row",
                                      { staticClass: "rpcInstructions" },
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "rpcQR",
                                            attrs: { md: "auto" },
                                          },
                                          [
                                            _c("svg-image", {
                                              attrs: { image: "QR" },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "h6",
                                              {
                                                staticStyle: { color: "#aaa" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.ballotData.mregOrderId
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("b-col", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t("rpc.instructions.point")
                                            ),
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-modal",
                                        rawName: "v-b-modal.delegationModal",
                                        modifiers: { delegationModal: true },
                                      },
                                    ],
                                    attrs: { variant: "primary" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("rpc.instructions.btn"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("delegation-modal"),
                                _vm._v(" "),
                                _c("div", { staticClass: "rpcDelegated" }, [
                                  _c("div", { staticClass: "groupLabel" }, [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("rpc.delegation.label"))
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "statusTransferred" },
                                    [
                                      _c(
                                        "b-row",
                                        { staticClass: "status" },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { sm: "auto" } },
                                            [
                                              _c("svg-image", {
                                                attrs: {
                                                  image: "iconDelegated",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("b-col", [
                                            _c("h6", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "rpc.delegation.statuslabel"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "rpc.delegation.statusdesc"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("table", [
                                    _c("tbody", [
                                      _c("tr", [
                                        _c("td", { staticClass: "heady" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("rpc.delegation.rname")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [_vm._v("Pengambil Respek")]),
                                      ]),
                                      _vm._v(" "),
                                      _c("tr", [
                                        _c("td", { staticClass: "heady" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("rpc.delegation.remail")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v("pengambil@respek.com"),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("tr", [
                                        _c("td", { staticClass: "heady" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("rpc.delegation.rphone")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [_vm._v("08123456789")]),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  { attrs: { variant: "primary" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("rpc.delegation.cancel"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showRaceDayInfo
                    ? _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c(
                            "b-card",
                            {
                              staticClass: "dashCard",
                              attrs: {
                                title: _vm.$t("raceday.card.head"),
                                "img-src": "/public/images/rd.jpg",
                                "img-alt": "Race Day",
                                "img-top": "",
                              },
                            },
                            [
                              _c("b-card-text", [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(_vm.$t("raceday.card.desc")) +
                                    "\n\t\t\t\t\t"
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    href: "https://borobudurmarathon.com/race-day",
                                    block: "",
                                    variant: "primary",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("raceday.card.btn")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/HomeView.vue